import { FC, useLayoutEffect, useRef } from "react";
import AppNavbar from "./navbar";
import { TFunction } from "i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "src/routes";
import { currentLanguage } from "src/i18n/type";

interface HeaderProps {
  maxWidth: number;
  screenHeight: number;
  screenWidth: number;
  t: TFunction<"translation", undefined>;
  onHeightChange: (height: number) => void;
  headerHeight: number;
}

const Header: FC<HeaderProps> = (props: HeaderProps) => {
  const navigate = useNavigate();

  const {
    t,
    maxWidth,
    screenWidth,
    screenHeight,
    onHeightChange,
    headerHeight,
  } = props;
  const headerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (headerRef.current) {
      onHeightChange(headerRef.current.getBoundingClientRect().height);
    }
  }, [screenWidth, screenHeight, onHeightChange]);

  return (
    <header
      ref={headerRef}
      className="light-bg border-bottom"
      style={{ position: "sticky", top: 0, zIndex: 9999999 }}
    >
      {screenWidth > 760 && (
        <div
          className="container-fluid py-4 d-sm-flex justify-content-center align-items-center gap-5 fw-bold text-primary"
          style={{ maxWidth: maxWidth }}
        >
          <div className="d-flex align-items-center">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.png`}
              width={150}
              alt={t("general.riskBrandLogo")}
              title={t("general.riskBrandLogo")}
              style={{ cursor: "pointer" }}
              onClick={() => navigate(ROUTES.contact[currentLanguage])}
            />
          </div>
          <div
            className="d-flex align-items-center gap-2"
            style={{ whiteSpace: "nowrap" }}
          >
            <span>📞</span>
            <a
              style={{ textDecoration: "none", color: "var(--primary)" }}
              href={`tel:${t("general.phoneNumber")}`}
            >
              {t("general.phoneNumber")}
            </a>
          </div>
          <div className="d-flex align-items-center gap-2">
            <span>✉️</span>
            <a
              style={{ textDecoration: "none", color: "var(--primary)" }}
              href={`mailto:${t("general.email")}`}
            >
              {t("general.email")}
            </a>
          </div>
          <div className="d-flex align-items-center gap-2">
            <span>📍</span>
            <span>{t("general.address")}</span>
          </div>

        </div>
      )}
      <AppNavbar
        t={t}
        maxWidth={maxWidth}
        screenWidth={screenWidth}
        headerHeight={headerHeight}
      />
    </header>
  );
};

export default Header;
